import organisationMessageTemplates from "./organisation-message-templates";

export const ORGANISATION_MESSAGE_TEMPLATES_NAMESPACE =
  "organisations/organisationMessageTemplates";

export default organisationMessageTemplates;
